import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import React from 'react';
import PropTypes from 'prop-types';
import styles from '../../node_modules/@flixbus/honeycomb/dist/scss/components/input.scss.js';
import HoneyBem from '../../packages/honey-bem/honey-bem.js';
import PropsUtils from '../../packages/props-utils/props-utils.js';
import { InnerRefPropType } from '../../packages/props-utils/prop-types.js';
import { InlineLabel } from '../_atoms/inline-label/inline-label.js';
import { InputField } from '../_atoms/input-field/input-field.js';
import { InputInfoChildren, InputInfo } from '../_atoms/input-info/input-info.js';
import '../_atoms/nav-elem/nav-elem.js';
import { inputLabelValidator } from '../../prop-types-validators/input-label-validator.js';
import { ALLOWED_INPUT_TYPES } from './types.js';
import { iconValidator, handleIcon } from './input-utils.js';
import { Injecss } from '../../packages/injecss/injecss.js';

const bem = new HoneyBem('input', styles);
function Input(_a) {
  var {
      extraClasses,
      label,
      id,
      disabled = false,
      valid,
      loading = false,
      type = 'text',
      info,
      infoError,
      iconLeft,
      iconRight,
      inlineLabelLeft,
      inlineLabelRight,
      controllers,
      'aria-describedby': ariaDescribedBy,
      innerRef,
      hasInlineLabelAddon = false
    } = _a,
    rest = __rest(_a, ["extraClasses", "label", "id", "disabled", "valid", "loading", "type", "info", "infoError", "iconLeft", "iconRight", "inlineLabelLeft", "inlineLabelRight", "controllers", 'aria-describedby', "innerRef", "hasInlineLabelAddon"]);
  const classNames = bem.b({
    disabled,
    'has-icon-right': iconRight,
    'has-controllers': controllers,
    error: !loading && valid === false,
    valid: !loading && valid === true,
    loading
  }, extraClasses);
  /**
   * Creates prioritized description id value by pushing all possible descriptions in order;
   * 1st: the left inline label (if present);
   * 2nd: the right inline label (if present);
   * 3rd: the inputInfo id (if `info` is present));
   */
  const describedByIds = PropsUtils.handleAriaDescribedBy(id, {
    inlineLabelLeft: inlineLabelLeft && !hasInlineLabelAddon,
    inlineLabelRight,
    info,
    ariaDescribedBy
  });
  return /*#__PURE__*/React.createElement("div", {
    className: classNames
  }, label && PropsUtils.handleLabel({
    label,
    inputId: id,
    bem
  }), /*#__PURE__*/React.createElement("div", {
    className: bem.e('container')
  }, inlineLabelLeft && (/*#__PURE__*/React.createElement(InlineLabel, {
    id: "left-".concat(id),
    className: bem.e('inline-label')
  }, inlineLabelLeft)), iconLeft && handleIcon(iconLeft, bem.e('icon')), /*#__PURE__*/React.createElement(InputField, Object.assign({
    ref: innerRef,
    id: id,
    className: bem.e('field'),
    type: type,
    disabled: disabled,
    "aria-errormessage": "infoError-".concat(id),
    valid: valid,
    "aria-describedby": describedByIds,
    busy: loading
  }, rest)), /*#__PURE__*/React.createElement("span", {
    className: bem.e('feedback-icon'),
    "aria-hidden": "true"
  }), iconRight && handleIcon(iconRight, bem.e('icon')), controllers && (/*#__PURE__*/React.createElement("div", {
    className: bem.e('controllers')
  }, controllers.map(controller => handleIcon(controller, bem.e('icon'))))), inlineLabelRight && (/*#__PURE__*/React.createElement(InlineLabel, {
    id: "right-".concat(id),
    className: bem.e('inline-label')
  }, inlineLabelRight))), /*#__PURE__*/React.createElement(InputInfo, {
    id: id,
    error: true,
    className: bem.e('info')
  }, valid === false ? infoError : ''), info && /*#__PURE__*/React.createElement(InputInfo, {
    id: id,
    className: bem.e('info')
  }, info));
}
Input.displayName = 'Input';
Input.propTypes = {
  extraClasses: PropTypes.string,
  label: inputLabelValidator(),
  id: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  valid: PropTypes.bool,
  loading: PropTypes.bool,
  type: PropTypes.oneOf(ALLOWED_INPUT_TYPES),
  info: InputInfoChildren,
  infoError: InputInfoChildren,
  iconLeft: iconValidator(),
  iconRight: iconValidator(),
  inlineLabelLeft: PropTypes.node,
  inlineLabelRight: PropTypes.node,
  innerRef: InnerRefPropType,
  hasInlineLabelAddon: PropTypes.bool
};
var Input$1 = Injecss(Input, styles);

export { Input, Input$1 as default };
